import { createContext, useContext, useState } from "react";

const AIChatContext = createContext();

export const AIChatProvider = ({ children }) => {
  const [chatOpen, setChatOpen] = useState(false);

  const openChat = () => setChatOpen(true);
  const closeChat = () => setChatOpen(false);

  return (
    <AIChatContext.Provider value={{ chatOpen, openChat, closeChat }}>
      {children}
    </AIChatContext.Provider>
  );
};

export const useAIChat = () => useContext(AIChatContext);
